module.exports = __webpack_public_path__ + "static/media/talisis-black-color.5625e769.svg";